import { render, staticRenderFns } from "./task_forward_messaging.vue?vue&type=template&id=8192e6d2&scoped=true"
import script from "./task_forward_messaging.vue?vue&type=script&lang=js"
export * from "./task_forward_messaging.vue?vue&type=script&lang=js"
import style0 from "./task_forward_messaging.vue?vue&type=style&index=0&id=8192e6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8192e6d2",
  null
  
)

export default component.exports